import { render } from 'react-dom';
import React from 'react';
import Tooltip, { TooltipProps } from '../../components/restyled/Tooltip';

const attachTooltip = (tooltipWrapperElement: HTMLElement, props: TooltipProps) => {
    render(<Tooltip {...props} />, tooltipWrapperElement);
};

export default attachTooltip;
